module.exports = __webpack_public_path__ + "static/media/Schedule-1.1ced35fc.png";